import { QuestionOutlineIcon } from "@chakra-ui/icons";
import { Box, Icon, Tooltip } from "@chakra-ui/react";
import React from "react";
import { Image } from "@chakra-ui/react";

export const TooltipCustom: React.FC<any> = (props: {
  label: string;
  fontSize?: any;
  style?: any;
}) => {
  const { label, fontSize, style } = props;

  return (
    <Tooltip label={label} fontSize={fontSize ?? "sm"} hasArrow placement="top">
      <Box {...style} ml="6px" opacity={0.7} _hover={{ opacity: 1 }} cursor="help">
        <Image
          src="/assets/tooltip.svg"
          alt="Help"
          width="18px"
          height="18px"
          filter="invert(0.7) sepia(1) saturate(2) hue-rotate(155deg)"
        />
      </Box>
    </Tooltip>
  );
};
